import querySerializer from 'querystring';

import { redirect } from 'redux-first-router';

import nauth from 'lib/nauth';

import {
  VISITED_APP,
  VISITED_COMPONENT,
  VISITED_CONTRACT,
  VISITED_FOLDER,
  VISITED_PAGE,
  VISITED_REPORTS,
  VISITED_SEARCH
} from './const';
import { visitLogin } from './actions';

const authRoutes = new Set([
  VISITED_APP,
  VISITED_COMPONENT,
  VISITED_CONTRACT,
  VISITED_FOLDER,
  VISITED_PAGE,
  VISITED_REPORTS,
  VISITED_SEARCH
]);

export default {
  // extra objects passed in bag param
  extra: {
    nauth,
    location: window.location
  },

  /**
   * ensure user is authenticated and redirect to login if not
   * @param {Function} dispatch - redux dispatch
   * @param {Function} getState - redux getState
   * @param {object} bag - redux first router bag
   * @param {object} bag.action - redux action describing target route
   * @param {object} bag.extra - extra objects
   */
  onBeforeChange(dispatch, getState, { action, extra }) {
    const { nauth } = extra;
    if (!nauth.getNauthTokenCookie() && authRoutes.has(action.type)) {
      const encodedAction = encodeURIComponent(JSON.stringify(action));
      dispatch(redirect(visitLogin({ encodedAction })));
    }
  },

  // querystring support
  querySerializer
};
